import EventBus from "../services/event-bus";
import { EVENTS } from "../services/constants";
import UserService from '../services/user-service';
import UrlService from '../services/url-service';
import PromoService from '../services/PromoService'
import InstallerService from '../services/installer-service';

EventBus.$on(EVENTS.shopChanged,(shop) => {
	window.clarity?.('set', 'ShopId', shop.ShopId);
	window.clarity?.('set', 'admin', UrlService.isInAdmin());
	window.clarity?.('set', 'manager', UrlService.isInManager());
	if (!InstallerService.isInAdmin()) {
		// cannot use UrlService because $state has not navigated yet to current page
		PromoService.displayPromoMessage(shop);
	}
})
EventBus.$on(EVENTS.clientLogin,(client) => {
	window.clarity?.('identify', client?.ClientId);
})

angular.module('eatself').component('angularApp',{
	bindings: {},
	// let a = ({
	controllerAs: 'vm',
	controller: angular.module('eatself').classy.controller({
	// name: 'AppController',
	inject: ['$injector', '$rootScope','$scope','UiService','ADMIN','ShopService','$state','$stateParams', '$rootScope','EVENTS','CartService','principal','$timeout','$uibModal','PRODUCT_TYPES'],
	init() {
		EventBus.$on(EVENTS.route.after,() => {
			if (this.isInAdmin()) {
				$('body').addClass('adminBo');
			} else {
				$('body').removeClass('adminBo');
			}
		});
		UrlService.angularLoaded(this.$injector);
		this.$rootScope.$on('$stateChangeSuccess',(event) => {
			if (this.ShopService.shop) {
				this.currentTreeItem = this.ShopService.getItem(this.$stateParams.tid, this.ShopService.shop.productTree);
			}
		});
		this.loading = true;
		this.$scope.$watch(_ => UserService.user,user => this.user = user);
		if (this.ADMIN) {
			this.loading = false;
		}
		if (!this.ShopService.qShop) {
			this.loading = false;
		}
		EventBus.$on(this.EVENTS.shopLoadError, _ => this.loading = false);
		EventBus.$on(this.EVENTS.shopChanged,(shop) => {
			this.loading = false;
			this.shop = shop;
		});
		this.detectMobileApp();
	},
	methods: {
		detectMobileApp() {
			this.isMobileApp = false;
			if (navigator.platform.substr(0,2) === 'iP'){
				let ios_without_webview = true;
				if (window.indexedDB) {
					ios_without_webview = false;
					let ios_webview = true;
					this.isMobileApp = true;
				}
			}
			let ua = navigator.userAgent;
			if (ua.indexOf('vw') != -1 && ua.indexOf('Chrome') != -1 && ua.indexOf('Mobile') != -1) {
				this.isMobileApp = true;
			}
		},
		toggleSidebar(open) {
			this.UiService.toggleSidebar(open);
		},
		isInAdmin() {
			let result = this.$state.includes("admin") || this.$state.includes("admin1") || this.$state.includes("admin2");
			return result;
		},
		includes(state) {
			return this.$state.includes(state);
		},
	}
}),
template: `
<div ng-hide="vm.loading" class="app-container" ng-class="{ 'dark-mode': vm.shop && vm.shop.info.display.darkMode }">
	<install-banner></install-banner>
		<navbar ng-if="!vm.includes('manager') && !vm.includes('admin2') && !vm.includes('admin1')" style="display: block"></navbar>
		<navbar1></navbar1>

		<div ng-if="!vm.includes('admin2')" id='overlay'></div><!-- / OVERLAY PANIER -->

		<div ui-view class="uvContainer clearfix" style="min-height: 100%"></div>
		<!-- Sidebar Menu Left-->
		<div ng-if="!vm.includes('admin2') && !vm.includes('admin1')" id="wrapper" class="sideWrap menuClosed cartClosed" style="position: absolute; z-index: 2">

			<cart></cart>

			<sidebar></sidebar>

			<section id="page-content-wrapper" style="min-height: 100%"><!-- Wrapper for leftmenu -->
				<div id='menuOverlay' ng-click="vm.toggleSidebar(false)"></div><!-- / OVERLAY Menu left -->
				<div style="height: 123px"></div>
			</section><!-- /#page-content-wrapper -->
			<!-- FOOTER -->
			<style>
				footer {
					bottom: 0;
					left: 0;
					right: 0;
					z-index: 1;
				}

				@media (max-width: 767px) {
					/*footer {
						margin-top: 70px;
						bottom: 70px;
					}*/
				}
			</style>
		</div><!-- /#wrapper -->


	<div growl></div>
	<div growl reference="1" limit-messages="1"></div>

	<mobile-footer id="mobile-footer" ng-if="!vm.includes('admin2') && !vm.includes('admin1') && (!vm.currentTreeItem || (vm.currentTreeItem.product.ty != vm.PRODUCT_TYPES.Menu))"></mobile-footer>
	<modal-user-navigation ng-if="!vm.includes('admin2') && !vm.includes('admin1')"></modal-user-navigation>
	<modal-cms-navigation ng-if="!vm.includes('admin2') && !vm.includes('admin1')"></modal-cms-navigation>
	<modal-template></modal-template>
</div>
`,
});

